import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component, inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {fuseAnimations} from "@fuse/animations";
import {MatIcon} from "@angular/material/icon";
import {MatRipple} from "@angular/material/core";
import {MatTooltip} from "@angular/material/tooltip";
import {DatePipe, DecimalPipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {TranslocoDirective, TranslocoPipe} from "@ngneat/transloco";
import {RouterLink} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {FuseCardComponent} from "../../../../@fuse/components/card";
import {
    AppResourceExtraInfo,
    FeatModule,
    getFeatureMap, getMoreInfoAboutResource, ResourceType
} from "../../../features/admin/components/feat-mgmt/feat-mgmt.types";
import {FuseConfirmationConfig, FuseConfirmationService} from "../../../../@fuse/services/confirmation";
import {FormsModule} from "@angular/forms";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatSlider, MatSliderThumb} from "@angular/material/slider";
import {MatDivider} from "@angular/material/divider";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatPrefix} from "@angular/material/input";

@Component({
    selector       : 'contact-component',
    templateUrl    : './prices-page.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    animations   : fuseAnimations,
    standalone     : true,
    imports: [
        MatIcon,
        MatRipple,
        MatTooltip,
        NgIf,
        TranslocoDirective,
        TranslocoPipe,
        RouterLink,
        MatButton,
        DatePipe,
        FuseCardComponent,
        NgForOf,
        NgSwitchCase,
        NgClass,
        NgSwitch,
        FormsModule,
        MatCheckbox,
        MatSlider,
        MatSliderThumb,
        MatDivider,
        DecimalPipe,
        MatButtonToggle,
        MatButtonToggleGroup,
        MatPrefix
    ],
})
export class PricesPageComponent implements OnInit, OnDestroy
{
    featModules: FeatModule[] = [];
    appResources: AppResourceExtraInfo[] = [];
    tabSelected:'calculator'|'modules'|'resources' = 'modules';
    resourceVisible=true;
    modulesVisible=true;
    calculatorVisible=true;
    input = {
        full:false,
        modCalendar:false,
        modDocClinic:false,
        modDocs:false,
        modRapoarte:false,
        modSterilizare:false,
        modMultimedia:false,
        modRecall:false,
        modFinancial:false,
        units: 1,
        sms:false,
        email:false,
        programari: 5,
        percSMS:5,
        percEmail:5,
        confirmare:false,
        reminder1:false,
        reminder2:true,
    }

    output={
        smsNr:0,
        smsCost:0,
        emailNr:0,
        emailCost:0,
        costUnit:0,
        costModCalendar:0,
        costModDocClinic:0,
        costModDocs:0,
        costModRapoarte:0,
        costModSterilizare:0,
        costModMultimedia:0,
        costModRecall:0,
        costModFinancial:0,
        total:0,
        costFix:0,
        costRes:0
    }

    private readonly _cdrf:ChangeDetectorRef = inject(ChangeDetectorRef);
    private readonly _fuseConfirmationService:FuseConfirmationService = inject(FuseConfirmationService);

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        getFeatureMap().forEach((value: FeatModule, key: string) => {
            this.featModules.push(value);
            this._cdrf.detectChanges();
        });

        this.featModules = this.featModules.filter(module => module.internalPrefixCode != '9');
        this.featModules.sort((a,b) => {
            if(a.active && b.active){
                return a.internalPrefixCode.localeCompare(b.internalPrefixCode);
            }
            if(a.active && !b.active){
                return -1;
            }
            if(!a.active && b.active){
                return 1;
            }
            return 0;
        });

        this.initAppResourceType(ResourceType.SMS, 0.3);
        this.initAppResourceType(ResourceType.WORK_UNIT, 50);
        this.initAppResourceType(ResourceType.STORAGE, 2);
        this.initAppResourceType(ResourceType.EMAIL, 0.05);
        this.initAppResourceType(ResourceType.AI_TOKENS, 0.05);
        this.updateOffer();

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {

    }


    initAppResourceType(type:ResourceType, price:number){
        const appResource: AppResourceExtraInfo =  {
            id: "1",
            pricePerResource: price,
            availableResourceCount: 0,
            resourceType: type,
            cover: '',
            name: '',
            resRemainLabel: '',
            isAvailable: true,
            canBuy: false,
            actionText: '',
            actionIcon: ''
        }

        switch (type) {
            case ResourceType.AI_TOKENS:
                appResource.name = "Token AI";
                appResource.cover = "assets/images/ui/smm/module-mgmt/ai-token.png";
                appResource.resRemainLabel = "Cost / token";
                appResource.isAvailable = false;
                appResource.actionText = "Indisponibil";
                appResource.actionIcon = "heroicons_solid:x-circle";
                break;
            case ResourceType.EMAIL:
                appResource.name = "Mesaje E-mail";
                appResource.cover = "assets/images/ui/smm/module-mgmt/email.png";
                appResource.resRemainLabel = "Cost / E-mail:";
                appResource.isAvailable = false;
                appResource.actionText = "Indisponibil";
                appResource.actionIcon = "heroicons_solid:x-circle";
                break;
            case ResourceType.SMS:
                appResource.name = "Mesaje SMS";
                appResource.cover = "assets/images/ui/smm/module-mgmt/SMS.png";
                appResource.resRemainLabel = "Cost / SMS";
                appResource.isAvailable = true;
                appResource.actionText = "Cumpara";
                appResource.actionIcon = "heroicons_solid:shopping-cart";
                break;
            case ResourceType.STORAGE:
                appResource.name = "Spatiu media";
                appResource.cover = "assets/images/ui/smm/module-mgmt/storage.png";
                appResource.resRemainLabel = "Cost / 1 Gb / luna";
                appResource.isAvailable = true;
                appResource.canBuy = false;
                appResource.actionText = "";
                appResource.actionIcon = "heroicons_solid:x-circle";
                break;
            case ResourceType.WORK_UNIT:
                appResource.name = "Unit de lucru";
                appResource.cover = "assets/images/ui/smm/module-mgmt/dental_unit.png";
                appResource.resRemainLabel = "Cost / unit / luna";
                appResource.isAvailable = true;
                appResource.actionText = "Adauga";
                appResource.actionIcon = "heroicons_solid:plus";
                break;
        }
        this.appResources.push(appResource);
    }

    getMoreInfo(appResource:AppResourceExtraInfo){
        const moreInfo = getMoreInfoAboutResource(appResource.resourceType);

        let confirm:FuseConfirmationConfig = {
            "title": moreInfo.title,
            "message": moreInfo.message,
            "icon": {
                "show": true,
                "name": "heroicons_outline:information-circle",
                "color": "primary"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": "OK",
                    "color": "primary"
                },
                "cancel": {
                    "show": false,
                    "label": "Cancel"
                },
            },
            "dismissible": true
        }

        // Open the confirmation and save the reference
        const dialogRef = this._fuseConfirmationService.open(confirm);

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if(result == "confirmed"){

            }
        });
    }

    updateFull(){
        this.input.modSterilizare = this.input.full;
        this.input.modCalendar = this.input.full;
        this.input.modDocs = this.input.full;
        this.input.modMultimedia = this.input.full;
        this.input.modSterilizare = this.input.full;
        this.input.modDocClinic = this.input.full;
        this.input.modRapoarte = this.input.full;
        this.input.modFinancial = this.input.full;
        this.input.modRapoarte = this.input.full;
        this.input.modRecall = this.input.full;
        this.input.sms = this.input.full;
        this.updateOffer();
    }

    checkFull(){
        this.input.full = this.input.modSterilizare &&
        this.input.modCalendar&&
        this.input.modDocs &&
        this.input.modMultimedia &&
        this.input.modSterilizare &&
        this.input.modDocClinic &&
        this.input.modRapoarte &&
        this.input.modFinancial &&
        this.input.modRapoarte &&
        this.input.modRecall &&
        this.input.sms;
    }

    updateOffer() {
        this.checkFull();
        const prcSMS = this.input.email ? this.input.percSMS * 10: 100;
        const prcEmail = this.input.sms ? this.input.percEmail * 10: 100;
        //nr mesaje / programare
        const nrMsj = (this.input.confirmare?1:0)+(this.input.reminder1?1:0)+(this.input.reminder2?1:0);
        const nrZileLucratoare = 20;
        const costperSMS = 0.3;
        const costperEmail = 0.05;
        const marjaEroareMesaje=0.3; //+30%

        this.output.smsNr = (this.input.sms ? this.input.programari * nrMsj * nrZileLucratoare : 0) * prcSMS/100;
        this.output.smsNr += this.output.smsNr * marjaEroareMesaje;
        this.output.smsCost = this.output.smsNr * costperSMS;
        this.output.emailNr = (this.input.email ? this.input.programari * nrMsj * nrZileLucratoare : 0) * prcEmail/100;
        this.output.emailNr += this.output.emailNr * marjaEroareMesaje;
        this.output.emailCost = this.output.emailNr * costperEmail;

        this.output.costUnit = ((this.input.units-1) * 50);
        this.output.costModCalendar=this.input.modCalendar ? 10 : 0;
        this.output.costModDocClinic=this.input.modDocClinic ? 15 : 0;
       this.output.costModDocs=this.input.modDocs ? 10 : 0;
       this.output.costModRapoarte=this.input.modRapoarte ? 10 : 0;
       this.output.costModSterilizare=this.input.modSterilizare ? 10 : 0;
       this.output.costModMultimedia=this.input.modMultimedia ? 20 : 0;
       this.output.costModRecall=this.input.modRecall ? 10 : 0;
       this.output.costModFinancial=this.input.modFinancial ? 10 : 0;
       this.output.total =
           this.output.smsCost +
           this.output.emailCost +
           this.output.costUnit +
           this.output.costModCalendar +
           this.output.costModDocClinic +
           this.output.costModDocs +
           this.output.costModRapoarte +
           this.output.costModSterilizare +
           this.output.costModMultimedia +
           this.output.costModRecall +
           this.output.costModFinancial
       ;
        this.output.costRes= this.output.smsCost +  this.output.emailCost;
        this.output.costFix=this.output.total - this.output.costRes;
    }

    getFMap(){
        return getFeatureMap();
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


}
